export default __webpack_public_path__ + "static/banner-desktop2x-efc4a2a5a1db7b71ec37a10d40e11e87.png";